import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import '../styles/Clientes.css';
import { reporteService } from '../services/api';

const PrestamosVencidos = () => {
  const [prestamos, setPrestamos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { codigo } = useParams();

  const getRoute = (path) => (codigo ? `/${codigo}${path}` : path);

  useEffect(() => {
    loadPrestamos();
  }, []);

  const loadPrestamos = async () => {
    try {
      setLoading(true);
      setError('');

      const response = await reporteService.getPrestamosVencidos();

      setPrestamos(response.data.prestamos || []);
    } catch (err) {
      console.error('Error:', err);
      setError(err.response?.data?.error || err.message || 'Error al cargar los préstamos');
    } finally {
      setLoading(false);
    }
  };

  const formatMoney = (amount) => {
    return `$${(amount || 0).toLocaleString('es-DO', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  };

  const irAPlanPagos = (prestamoId) => {
    if (!prestamoId) return;
    navigate(getRoute(`/pagos?opcion=plan&prestamoId=${prestamoId}`));
  };

  if (loading) return <div className="loading">Cargando...</div>;

  return (
    <div className="clientes-page">
      <div className="clientes-header">
        <h1>Préstamos Vencidos</h1>
        <button
          className="btn"
          onClick={() => navigate(getRoute('/dashboard'))}
          style={{background: '#666', color: '#fff'}}
        >
          ← Volver al Dashboard
        </button>
      </div>

      {error && <div className="banner error">{error}</div>}

      <div className="card">
        <div className="card-title" style={{background: '#c62828'}}>
          Préstamos Amortizados
        </div>

        {prestamos.length === 0 ? (
          <p style={{padding: '1rem', textAlign: 'center', color: '#666'}}>
            Ningún dato disponible en esta tabla
          </p>
        ) : (
          <div style={{overflowX: 'auto'}}>
            <table className="table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nombre</th>
                  <th>Monto</th>
                  <th>Capital</th>
                  <th>Interés</th>
                  <th>A saldar</th>
                  <th>Vencidas</th>
                  <th>Cuota</th>
                  <th>Modalidad</th>
                  <th>Mora</th>
                </tr>
              </thead>
              <tbody>
                {prestamos.map((prestamo) => {
                  const saldo = prestamo.total - ((prestamo.total / prestamo.cuotas) * prestamo.cuotas_pagadas);
                  const cuota = prestamo.total / prestamo.cuotas;
                  const cuotasVencidas = prestamo.cuotas - prestamo.cuotas_pagadas;
                  return (
                    <tr key={prestamo.id}>
                      <td>
                        <button
                          type="button"
                          onClick={() => irAPlanPagos(prestamo.id)}
                          style={{
                            border: 'none',
                            background: 'none',
                            padding: 0,
                            margin: 0,
                            color: '#007bff',
                            cursor: 'pointer',
                            fontWeight: 600
                          }}
                          title="Ver reporte de pago del préstamo"
                        >
                          #{prestamo.id}
                        </button>
                      </td>
                      <td>{prestamo.cliente?.nombres} {prestamo.cliente?.apellidos}</td>
                      <td>{formatMoney(prestamo.monto_prestado)}</td>
                      <td>{formatMoney(prestamo.capital)}</td>
                      <td>{formatMoney(prestamo.interes)}</td>
                      <td>{formatMoney(saldo)}</td>
                      <td>{cuotasVencidas}</td>
                      <td>{formatMoney(cuota)}</td>
                      <td>{prestamo.modalidad}</td>
                      <td>{formatMoney(0)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default PrestamosVencidos;
